import { useState } from 'react'
import useDeleteSavedBasket from '../../../Components/BasketPage/Hooks/useDeleteSavedBasket'
import LoadingSpinner from '../../../Components/Components/LoadingSpinner'
import YesNoMessageModal from '../../../Components/Components/Modals/YesNoMessageModal'
import SavedBasketTabTableContent from './SavedBasketTabTableContent';
import { CheckBox } from 'devextreme-react/check-box';
import { useParams } from '../../../Providers/ParamsProvider';

const SavedBasketTab = ({ savedBaskets, handleGetSavedBasket, isLoadingSavedBaskets, handleCheckUncheckBasket, handleSelectUnSelectAllBaskets, setMessageModalFunctionTyp,
    setShowQuestionAboutReplaceBasket, handleMessageModalResult }) => {
    const { handleDeleteSavedBasket } = useDeleteSavedBasket()
    const [selectAllBaskets, setSelectAllBaskets] = useState(false)
    const [showDeleteSavedBasketQuestion, setShowDeleteSavedBasketQuestion] = useState({ show: false, name: '', basketId: -1 })
    const [isLoading, setIsLoading] = useState(false)
    const { isMobile } = useParams()

    const handleDeleteSavedBasketFunc = async (e, basketId, basketName) => {
        e.stopPropagation()
        setShowDeleteSavedBasketQuestion({ show: true, name: basketName, basketId: basketId })
    }
    const handleDeleteSavedBasketQuestionAnswer = async (answer) => {
        if (answer) {
            setIsLoading(true)
            if (await handleDeleteSavedBasket(showDeleteSavedBasketQuestion.basketId)) {
                //teraz czeka na usuniece inaczej nie czekał i był błąd w pobieraniu
            }
            handleGetSavedBasket()
            setIsLoading(false)
        }
        setShowDeleteSavedBasketQuestion({ show: false, name: '', basketId: -1 })
    }
    if (isLoading) {
        return <LoadingSpinner />
    }
    return (
        <>
            <YesNoMessageModal
                show={showDeleteSavedBasketQuestion.show}
                onHide={handleDeleteSavedBasketQuestionAnswer}
                title={'Pytanie'}
                message={`Czy na pewno chcesz usunąć koszyk "${showDeleteSavedBasketQuestion.name}" ?`}
            />

            <div className="contaner main-container-holder">
                <div className="row">
                    <div className="row mt-2 mb-5" style={{ marginLeft: '0.01%' }}>
                        <div className="col-auto text-start">
                            <CheckBox
                                className="custom-checkbox"
                                value={selectAllBaskets}
                                onValueChange={() => {
                                    setSelectAllBaskets(prev => !prev)
                                    handleSelectUnSelectAllBaskets(savedBaskets, !selectAllBaskets)
                                }}
                            />
                        </div>
                        <div className="col-auto text-start">
                            <span>zaznacz wszystko</span>
                        </div>
                    </div>
                    {isLoadingSavedBaskets ? (<LoadingSpinner />) : (
                        <div className='table-responsive mb-5'>
                            <table className={`${isMobile ? 'table-font-small' : ''} table table-bordered`}>
                                <thead>
                                    <tr className='border-bottom border-top'>
                                        <th style={{ width: '7%' }}></th>
                                        <th style={{ width: "5%" }}>LP</th>
                                        <th style={{ width: "auto" }}>NAZWA</th>
                                        <th style={{ width: "12%", textAlign: 'right' }}>ILOŚĆ POZYCJI</th>
                                        <th style={{ width: "17%", textAlign: 'right' }}>WARTOŚĆ NETTO PLN</th>
                                        <th style={{ width: "5%" }}></th>
                                        <th style={{ width: "5%" }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {savedBaskets.map(basket =>
                                        <SavedBasketTabTableContent
                                            key={basket.basketId}
                                            basket={basket}
                                            isCheckedParam={selectAllBaskets}
                                            handleDeleteSavedBasketFunc={handleDeleteSavedBasketFunc}
                                            handleCheckUncheckBasket={handleCheckUncheckBasket}
                                            setMessageModalFunctionTyp={setMessageModalFunctionTyp}
                                            setShowQuestionAboutReplaceBasket={setShowQuestionAboutReplaceBasket}
                                            handleMessageModalResult={handleMessageModalResult}
                                        />)}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

export default SavedBasketTab